(function (Drupal) {
  Drupal.behaviors.fileDownload = {
    attach(context) {
      // Guard against repeat binding when the behavior re-attaches (AJAX,
      // BigPipe) — otherwise every click would trigger multiple downloads.
      const links = context.querySelectorAll('.file-download:not([data-file-download-init])');
      links.forEach((link) => {
        link.setAttribute('data-file-download-init', '1');
        link.addEventListener('click', (e) => {
          // Force download even if browser tries to open inline
          const url = link.getAttribute('href');
          if (!url) return;
          e.preventDefault();
          const a = document.createElement('a');
          a.href = url;
          a.download = link.querySelector('.file-download__name')?.textContent?.trim() || '';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      });
    },
  };
}(Drupal));
